import "../src/bootstrap.native";

import 'controllers';
import { Turbo } from '@hotwired/turbo-rails';
// data-turbo="true" to enable Drive on a per-element basis
Turbo.session.drive = false
